import axios from "axios";
import * as url from "../utils/urls";

export default {
  adminLogin: params => {
    return axios.post(url.loginUrl(), params);
  },

  getNotifications: (pageNo, pageSize, search, startDate, endDate) => {
    return axios.get(url.notificationsUrl(pageNo, pageSize, search, startDate, endDate));
  },

  sendPushNotification: params => {
    return axios.post(url.pushNotificationUrl(), params);
  },

  forgotPassword: params => {
    return axios.post(url.forgotPasswordUrl(), params);
  },

  verifyForgotToken: verifyToken => {
    return axios.post(url.verifyForgotTokenUrl(verifyToken));
  },

  resetPassword: params => {
    return axios.post(url.resetPasswordUrl(), params);
  },

  changePassword: params => {
    return axios.post(url.changePasswordUrl(), params);
  },

  getUsersList: (rowsPerPage, page, sortDirection) => {
    return axios.get(url.fetchUserListUrl(rowsPerPage, page, sortDirection));
  },

  singleUser: userId => {
    return axios.get(url.singleUserUrl(userId));
  },

  changeUserActiveStatus: params => {
    return axios.post(url.userActiveStatus(), params);
  },

  updateUser: params => {
    return axios.post(url.updateUserUrl(), params);
  },
  getFAQList: () => {
    return axios.get(url.fetchFAQListUrl());
  },

  addFAQ: params => {
    return axios.post(url.addFAQUrl(), params);
  },

  updateFAQ: params => {
    return axios.post(url.updateFAQUrl(), params);
  },

  deleteFAQ: params => {
    return axios.post(url.deleteFAQUrl(), params);
  },

  updateFAQPosition: params => {
    return axios.post(url.updateFAQPositionUrl(), params);
  },

  topPerformers: () => {
    return axios.get(url.topPerformersUrl());
  },

  searchUser: params => {
    return axios.post(url.searchUserUrl(), params);
  },

  dashboardChart: params => {
    return axios.post(url.dashboardChartUrl(), params, {
      skipSessionExpiration: true  // Don't auto-logout on 401 for dashboard charts
    });
  },

  modeChart: params => {
    return axios.post(url.modeChartUrl(), params);
  },

  carOwners: () => {
    return axios.post(url.carOwnersUrl());
  },

  pointsChart: params => {
    return axios.post(url.pointsChartUrl(), params);
  },

  getTotalUsersAndTrees: () => {
    return axios.get(url.totalUsersAndTrees());
  },

  getTodaysStats: () => {
    return axios.get(url.todaysStats());
  },

  getTrips: (pageNo, pageSize, filters = {}) => {
    return axios.get(url.fetchTripsUrl(pageNo, pageSize, filters));
  },

  verifyTrip: (tripId, status, verificationFailedReason, verificationFailedReasonText) => {
    const payload = {
      status,
    };

    // Add rejection reason fields if status is FAILED/REJECTED
    if (status === "FAILED" || status === "REJECTED") {
      if (verificationFailedReason) {
        payload.verificationFailedReason = verificationFailedReason;
      }
      if (verificationFailedReasonText) {
        payload.verificationFailedReasonText = verificationFailedReasonText;
      }
    }

    return axios.patch(url.verifyTripUrl(tripId), payload);
  },

  getAllChallenges: (pageNo, pageSize, status = "", type = "", mode = "", repetition = "") => {
    return axios.get(url.challengesUrl(pageNo, pageSize, status, type, mode, repetition));
  },

  createChallenge: (data) => {
    return axios.post(url.createChallengeUrl(), data);
  },

  getChallengeById: (id) => {
    return axios.get(url.singleChallengeUrl(id));
  },

  updateChallenge: (id, data) => {
    return axios.patch(url.singleChallengeUrl(id), data);
  },

  deleteChallenge: (id) => {
    return axios.delete(url.singleChallengeUrl(id));
  },

  getS3PresignedUrl: (key, contentType = 'image/jpeg') => {
    return axios.get(url.s3PresignedUrl(key, contentType));
  },

  getUserActivityDetails: (pageNo, pageSize, startDate, endDate) => {
    return axios.get(url.userActivityDetailsUrl(pageNo, pageSize, startDate, endDate));
  },

  getUserActivityStats: (startDate, endDate) => {
    return axios.get(url.userActivityStatsUrl(startDate, endDate));
  },
};
